/**
 * Created by daniesy on 13/04/2017.
 */
import moment from 'moment-timezone';

export default class {
    constructor(locale) {
        this.constructor.saveTimezone();
        this.constructor.setLocale(locale);
    }

    static saveTimezone() {
        document.cookie = "timezone="+moment.tz.guess()+"; path=/";
    }

    static setLocale(locale) {
        window.language = locale;
    }

}